module.exports = __webpack_public_path__ + "static/media/jhmyxt.bcfdefb0.png";